export default "__VITE_ASSET__Du5jC7JS__"